(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[676],{

/***/ 89826:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/financial-services",
      function () {
        return __webpack_require__(4503);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ financial_services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./src/landingPage/views/IndustryPages/components/IndustryHero/IndustryHero.jsx + 1 modules
var IndustryHero = __webpack_require__(9780);
// EXTERNAL MODULE: ./src/landingPage/views/IndustryPages/components/TextSection/TextSection.jsx + 1 modules
var TextSection = __webpack_require__(62211);
// EXTERNAL MODULE: ./src/landingPage/views/IndustryPages/components/IndustryMetrics/IndustryMetrics.jsx + 2 modules
var IndustryMetrics = __webpack_require__(91097);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
// EXTERNAL MODULE: ./src/landingPage/views/CaseStudy/components/DownloadCaseStudy.jsx
var DownloadCaseStudy = __webpack_require__(8716);
;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryMetrics/CaseStudySection.jsx



var CaseStudySection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "case_study",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: Anz/* default.src */.Z.src,
                alt: "ANZ",
                loading: "eager",
                width: "96",
                height: "31"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "ANZ is providing conditional approval on unsecured lending for small business customers in less than 20 minutes via ANZ GoBiz."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadCaseStudy/* default */.Z, {
                autoWidth: true,
                variant: "inverted",
                url: "/ANZ SME Lending Case Study.pdf",
                "data-test-id": "home-hero-button",
                children: "Download Case Study"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/views/IndustryPages/components/IndustryRecipes/IndustryRecipes.jsx + 1 modules
var IndustryRecipes = __webpack_require__(82634);
// EXTERNAL MODULE: ./src/landingPage/views/components/sections/DataProviders.jsx + 6 modules
var DataProviders = __webpack_require__(97065);
// EXTERNAL MODULE: ./src/landingPage/views/components/sections/Solutions.jsx + 8 modules
var Solutions = __webpack_require__(3296);
// EXTERNAL MODULE: ./src/landingPage/views/components/sections/Testimonial.jsx + 5 modules
var Testimonial = __webpack_require__(97281);
// EXTERNAL MODULE: ./src/landingPage/views/components/sections/GetStartedNew.jsx + 1 modules
var GetStartedNew = __webpack_require__(59547);
// EXTERNAL MODULE: ./src/landingPage/views/components/sections/Highlights.jsx + 1 modules
var Highlights = __webpack_require__(10974);
// EXTERNAL MODULE: ./src/landingPage/datasets/industryPages.js + 21 modules
var industryPages = __webpack_require__(59097);
;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/FinancialServices.jsx












var FinancialServices = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryHero/* IndustryHero */.R, {
                title: industryPages/* default.hero.financialServices.title */.Z.hero.financialServices.title,
                description: industryPages/* default.hero.financialServices.description */.Z.hero.financialServices.description,
                images: industryPages/* default.hero.financialServices.images */.Z.hero.financialServices.images
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSection/* TextSection */.a, {
                textData: industryPages/* default.textSection.financialServices */.Z.textSection.financialServices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryMetrics/* IndustryMetrics */.B, {
                metrics: industryPages/* default.metrics.financialServices */.Z.metrics.financialServices,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudySection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryRecipes/* IndustryRecipes */.$, {
                recipes: industryPages/* default.recipes.financialServices */.Z.recipes.financialServices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataProviders/* DataProviders */.R, {
                providers: industryPages/* default.dataProviders.financialServices */.Z.dataProviders.financialServices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Solutions/* Solutions */.q, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* Testimonial */.g, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStartedNew/* GetStartedNew */.b, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlights/* Highlights */.x, {})
        ]
    });
};

;// CONCATENATED MODULE: ./pages/industries/financial-services.jsx




var FinancialServicesPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/industries/financial-services",
                title: meta/* meta.industries.financialservices.title */.$.industries.financialservices.title,
                description: meta/* meta.industries.financialservices.description */.$.industries.financialservices.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialServices, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var financial_services = (FinancialServicesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,314,5675,8540,9474,9477,2892,8716,9774,2888,179], function() { return __webpack_exec__(89826); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);